
<template>
  <div>
    <v-dialog :value="dialog" scrollable persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Editando contatos</span>
        </v-card-title>
        <v-card-text>
          <v-col cols='12' v-if="false">
            <v-btn small text color="error" v-if="totalContacts < 2" @click="totalContacts += 1">Adicionar</v-btn>
            <v-btn small text color="grey" v-if="totalContacts == 2" @click="totalContacts -= 1">Remover</v-btn>
            <div v-if="totalContacts != null" v-for="(c, index) in totalContacts" :key="index">
              <v-col cols='12' >
                <v-text-field v-if="c < 2" v-model="new_employee.contacts_attributes.data[c - 1].attributes.telephone"
                  label="Fixo" v-mask="'(##) ####-####'"></v-text-field>
                <v-text-field v-if="c > 1 && new_employee.contacts_attributes.data[c - 1] != null"
                  v-model="new_employee.contacts_attributes.data[c - 1].attributes.telephone" label="Fixo"
                  v-mask="'(##) ####-####'"></v-text-field>
                <v-text-field v-if="c > 1 && new_employee.contacts_attributes.data[c - 1] == null"
                  v-model="new_employee.new_contacts_attributes.telephone" label="Fixo"
                  v-mask="'(##) ####-####'"></v-text-field>
              </v-col>
              <v-col cols='12'>
                <v-text-field v-if="c < 2" v-model="new_employee.contacts_attributes.data[c - 1].attributes.celphone"
                  label="Celular"  v-mask="'(##) # ####-####'"></v-text-field>
                <v-text-field v-if="c > 1 && new_employee.contacts_attributes.data[c - 1] != null"
                  v-model="new_employee.contacts_attributes.data[c - 1].attributes.celphone" label="Celular"
                  v-mask="'(##) # ####-####'"></v-text-field>
                <v-text-field v-if="c > 1 && new_employee.contacts_attributes.data[c - 1] == null"
                  v-model="new_employee.new_contacts_attributes.celphone" label="Celular"
                  v-mask="'(##) # ####-####'"></v-text-field>
              </v-col>
              <v-col cols='12'>
                <v-text-field v-if="c == 1" :value="new_employee.contacts_attributes.data[c - 1].attributes.email"
                  disabled persistent-hint hint="Deve ser alterado em dados do funcionário"
                  label="E-mail"></v-text-field>
                <v-text-field v-if="c > 1 && new_employee.contacts_attributes.data[c - 1] != null"
                  v-model="new_employee.contacts_attributes.data[c - 1].attributes.email" label="E-mail"></v-text-field>
                <v-text-field v-if="c > 1 && new_employee.contacts_attributes.data[c - 1] == null"
                  v-model="new_employee.new_contacts_attributes.email" label="E-mail"></v-text-field>
              </v-col>
              <v-divider></v-divider>
            </div>
          </v-col>
          <v-col cols='12'>
            <div v-for="(con, index) in new_employee.contacts_attributes" :key="index">
              <v-container grid-list-lg>
                <ContactForm :contact="con"></ContactForm>
                <v-divider></v-divider>
              </v-container>
            </div>
            <v-btn icon text color="error" :disabled="newContact == 0"
              @click="newContact -= 1"><v-icon>mdi-minus</v-icon></v-btn>
            <v-btn icon text color="primary" :disabled="new_employee?.contacts_attributes?.length == 2"
              @click="newContact += 1"><v-icon>mdi-plus</v-icon></v-btn>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="closeDialog" ></f-btn>
          <f-btn save @click="emitUpdate" ></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from "@/mixins/validations.js"
export default {
  name: 'EmployeeEditContactsDialog',
  mixins: [ validations ],
  props: {
    employee:{
      type: Object,
      default: () => { return {} },
    },
    change_dialog:{
      type: Boolean,
      default: false,
    }
  },
  components: {
    ContactForm:() => import("@/_backoffice/_registrations/components/shared/forms/ContactForm.vue"),
  },
  data() {
    return {
      new_employee:{
        id: null
      },
      dialog: false,
      totalContacts: null,
      newContact: 0,
    }
  },
  methods: {
    emitUpdate(){
      this.$emit('update', this.new_employee)
    },
    closeDialog(){
      this.$emit('close')
    },
  },
  watch:{
    change_dialog(nv, old){
      this.dialog = nv
    },
    dialog(nv) {
      if (nv) {
        var contacts = this.employee.data.attributes.contacts
        this.new_employee = {
          id: this.employee.data.id,
          contacts_attributes: [],
        }
        if (contacts != null) {
          contacts.data.forEach((contact, index) => {
            var { id, email, celphone, telephone } = contact.attributes
            var obj = {
              id: id,
              email: email,
              celphone: celphone,
              telephone: telephone
            }
            this.new_employee.contacts_attributes.push(obj)
          });
        } else {
          var obj = {
            email: null,
            celphone: null,
            telephone: null
          }
          this.new_employee.contacts_attributes.push(obj)
        }
      }
    },
    newContact(nv, ov) {
      var obj = {
        name: null,
        position: null,
        email: null,
        celphone: null,
        telephone: null
      }
      if (nv > ov) {
        this.new_employee.contacts_attributes.push(obj)
      } else if (nv < ov) {
        this.new_employee.contacts_attributes.pop()
      }
    },
  }
}
</script>